import { Controller } from '@hotwired/stimulus'

// Repeating guest name+email rows on the booking form. Clones a server-rendered
// <template> row, swapping the GUEST_INDEX placeholder for a unique index, and hides
// the "Add guest" button once maxValue rows exist (0 = unlimited).
export default class extends Controller {
  static targets = ['list', 'template', 'addButton', 'row']
  static values = { max: Number }

  add() {
    const html = this.templateTarget.innerHTML.replace(/GUEST_INDEX/g, this.nextIndex++)
    this.listTarget.insertAdjacentHTML('beforeend', html)
    this._refresh()
  }

  remove(event) {
    this.rowTargets.find((row) => row.contains(event.currentTarget))?.remove()
    this._refresh()
  }

  get nextIndex() {
    if (this._index === undefined) this._index = 0
    return this._index
  }
  set nextIndex(value) {
    this._index = value
  }

  _refresh() {
    const atMax = this.maxValue > 0 && this.rowTargets.length >= this.maxValue
    this.addButtonTarget.classList.toggle('hidden', atMax)
  }
}
